(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('moveUnitsBatchModalController', moveUnitsBatchModalController);

    moveUnitsBatchModalController.$inject = [
        '$translate',
        '$rootScope',
        '$scope',
        '$windowInstance',
        'units',
        'selectedUnitsbatches',
        'unitService',
        'unitId',
        'supplierService'
    ];

    function moveUnitsBatchModalController(
        $translate,
        $rootScope,
        $scope,
        $windowInstance,
        units,
        selectedUnitsbatches,
        unitService,
        unitId,
        supplierService
    ) {
        $scope.filteredUnits = units;

        $scope.unitOptions = {
            dataSource: new kendo.data.DataSource({
                data: $scope.filteredUnits,
                sort: {
                    field: "description",
                    dir: "asc",
                    compare: (a, b) => a.description > b.description ? 1 : b.description > a.description ? -1 : 0
                }
            }),
            dataValueField: 'id',
            dataTextField: 'description',
            optionLabel: $translate.instant('ADMIN_CUSTOMERS_SELECT_UNIT'),
            filter: "contains"
        };

        $scope.supplierOptions = {
            dataSource: new kendo.data.DataSource({
                data: $scope.suppliers ?? []
            }),
            dataValueField: 'supplierId',
            dataTextField: 'name',
            optionLabel: $translate.instant('ADMIN_UNIT_BATCH_MOVE_SELECT_SUPPLIER'),
            change: () => {
                var supplier = $("#supplier-selector").data("kendoDropDownList").dataItem();
                filterUnitsOnSupplierAndCategory(supplier);
            },
            filter: "contains"
        }

        function filterUnitsOnSupplierAndCategory(supplier) {
            //reset filteredUnits before filtering
            $scope.filteredUnits = units;

            $scope.filteredUnits = units.filter(u =>
                u.resourceId == $scope.productCategoryId);
            if (supplier && supplier.supplierId) {
                $scope.filteredUnits = $scope.filteredUnits.filter(u =>
                    u.supplierId == supplier.supplierId);
            }

            $scope.unitOptions.dataSource.data($scope.filteredUnits);
        }

        initController();
        function initController() {
            $scope.selectedUnit = units.find(u => u.id == unitId);
            $scope.productCategoryId = $scope.selectedUnit.resourceId;

            var filter = {
                isActive: true,
            }
            supplierService.getSuppliersByFilter(filter).then(result => {
                $scope.suppliers = result;
                $scope.supplierOptions.dataSource.data($scope.suppliers);

                $scope.selectedSupplier = $scope.suppliers.find(u => u.supplierId == $scope.selectedUnit.supplierId);
                $scope.filteredUnits = filterUnitsOnSupplierAndCategory($scope.selectedSupplier);
            });
        }

        $scope.validateForm = function(event) {
            event.preventDefault();
            if ($scope.validator.validate()) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'unitDetailsModalIndicator',
                    destination: '.k-widget.k-window',
                    overlay: true
                });

                if($scope.selectedUnit.id != unitId){
                    unitService.moveUnitBatches($scope.selectedUnit.id, selectedUnitsbatches).then(function(unitId){
                        $windowInstance.close(unitId);
                    })
                    .finally(function(){
                        $rootScope.$broadcast('hideBusyIndicator', 'unitDetailsModalIndicator');
                    });
                } else {
                    $windowInstance.close();
                    $rootScope.$broadcast('hideBusyIndicator', 'unitDetailsModalIndicator');
                }

            }
        }

        $scope.close = function(){
            $windowInstance.close();
        }
    }
})();
